import { Component, OnDestroy, inject } from '@angular/core';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { CoreSelectors } from '@next/core-lib';
import { RootState } from '@next/core-lib/app';
import { SummaryCardComponent } from '@next/core-lib/components';
import { TranslatePipe } from '@next/core-lib/i18n';
import { Store } from '@ngrx/store';
import { Observable, Subject, takeUntil } from 'rxjs';

import { FarmSettings } from '../../models/farm-settings.model';
import * as farmSettingsActions from '../../store/actions/farm-settings.actions';
import { getCurrentFarmSettings } from '../../store/selectors/farm-settings.selector';

@Component({
  selector: 'app-sustainability-overview',
  templateUrl: 'sustainability-overview.component.html',
  imports: [SummaryCardComponent, MatSlideToggle, TranslatePipe],
})
export class SustainabilityOverviewComponent implements OnDestroy {
  private readonly store = inject<Store<RootState>>(Store);

  private readonly destroyed$ = new Subject<void>();

  isLoading$: Observable<boolean> = this.store.select(CoreSelectors.selectLoading);
  farmSettings$: Observable<FarmSettings> = this.store.select(getCurrentFarmSettings);
  farmSettings: FarmSettings;
  enableCO2Calculation: boolean;

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {
    this.farmSettings$.pipe(takeUntil(this.destroyed$)).subscribe((farmSettings) => {
      if (farmSettings) {
        this.enableCO2Calculation = farmSettings.enableCO2Calculation;
        this.farmSettings = farmSettings;
      }
    });
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  onToggleCO2Calculation(newValue: boolean) {
    this.store.dispatch(
      farmSettingsActions.upsertFarmSettings({
        farmSettings: {
          ...this.farmSettings,
          enableCO2Calculation: newValue,
        },
      }),
    );
  }
}
